export const themeMixins =
  " --color-backdrop: 229 231 235; --color-paper: 255 255 255; ";
